module.exports = __webpack_public_path__ + "img/mama-3.c215c717.png";